import React, { Component } from 'react';
import axios from 'axios';


class Resume extends Component{
constructor(props){
  super(props);
  this.openNav = this.openNav.bind(this);
  this.closeNav =this.closeNav.bind(this);
}

handleAddOption = (e) => {
  e.preventDefault();
  const fields ={};
  fields.name  = e.target.elements.name.value.trim();
  e.target.elements.name.value='';
  fields.email  = e.target.elements.email.value.trim();
  e.target.elements.email.value='';
  fields.subject  = e.target.elements.subject.value.trim();
  e.target.elements.subject.value='';
  fields.message  = e.target.elements.message.value.trim();
  e.target.elements.message.value='';
  console.log(fields);
  axios.post('/api/resume/submit', fields)
   .then(res => 'hi')
   .catch(err =>'error occured');

   var para = document.createElement("h3");
   var node = document.createTextNode("Thank for Contacting. I will get back to you soon");
   para.appendChild(node);
   var element = document.getElementById("sent");
   element.appendChild(para);

}

openNav = () => {
    document.getElementById("mySidebar").style.width = "61%";
    document.getElementById("mySidebar").style.display = "block";
}

closeNav = () => {
    document.getElementById("mySidebar").style.display = "none";
}



  render() {
    return (
      <div>

      <nav className="w3-sidebar w3-hide-medium w3-hide-small" style={{width:"40%"}}>
        <div className="bgimg"></div>
      </nav>
      <nav className="w3-sidebar w3-black w3-animate-right w3-xxlarge" style={{display:"none",paddingTop:"80px",right:"0",zIndex:"2"}} id="mySidebar">
        <a href="javascript:void(0)" onClick={this.closeNav} className="w3-button w3-black w3-xxxlarge w3-display-topright" style={{padding:"0 12px"}}>
          <i className="fa fa-remove"></i>
        </a>
        <div className="w3-bar-block w3-center">
          <a href="#" className="w3-bar-item w3-button w3-text-grey w3-hover-black" onClick={this.closeNav}>Home</a>
          <a href="#about" className="w3-bar-item w3-button w3-text-grey w3-hover-black" onClick={this.closeNav}>About</a>
          <a href="#myskills" className="w3-bar-item w3-button w3-text-grey w3-hover-black" onClick={this.closeNav}>My Skills</a>
          <a href="#workexp" className="w3-bar-item w3-button w3-text-grey w3-hover-black" onClick={this.closeNav}>Work</a>
          <a href="#education" className="w3-bar-item w3-button w3-text-grey w3-hover-black" onClick={this.closeNav}>Education</a>
          {/* <a href="#portfolio" className="w3-bar-item w3-button w3-text-grey w3-hover-black" onClick={this.closeNav}>Portfolio</a> */}
          <a href="#contact" className="w3-bar-item w3-button w3-text-grey w3-hover-black" onClick={this.closeNav}>Contact</a>
        </div>
      </nav>
      <div className="w3-main w3-padding-large" style={{marginLeft:"40%"}}>

        <span className="w3-button w3-top w3-white w3-xxlarge w3-text-grey w3-hover-text-black" style={{width:"auto",right:"0"}} onClick={this.openNav}><i className="fa fa-bars"></i></span>

        <header className="w3-container w3-center" style={{padding:"50px 16px"}} id="home">
          <a href="#portfolio"><h1 className="w3-jumbo"  ><b>Amanjeet Singh </b></h1></a>
          <p><strong>Senior Frontend/UI/Fullstack Developer</strong></p>
          <img src={require('../../img/Resumepic.jpg')} className="w3-image w3-hide-large w3-hide-small w3-round" style={{display:"block",width:"60%",margin:"auto"}} />
          <img src={require('../../img/Resumepic.jpg')}  className="w3-image w3-hide-large w3-hide-medium w3-round" width="1000" height="1333" style={{marginBottom:'20px'}}/>
          <a href="https://www.linkedin.com/in/amanjeet-gilard-825515b4/" target="_blank"><i className="fa fa-linkedin w3-hover-opacity"></i></a>
          <a href="https://angel.co/amanjeet-singh-4" target="_blank"><i className="fa fa-angellist w3-hover-opacity"></i></a>
          <a href="https://calendly.com/amanjeetgilard-1/30min" target="_blank"><i className="fa fa-calendar w3-hover-opacity"></i></a>
          <a href="https://www.github.com/amanjeet17/" target="_blank"><i className="fa fa-github" aria-hidden="true"></i> </a>
          <br />
          <a href="Amanjeet_Singh_Resume.pdf" download="Amanjeet_Singh_Resume.pdf">
          <button className="w3-button w3-light-grey w3-padding-large w3-margin-top">
            <i className="fa fa-download"></i> Download Resume
          </button>
          </a>
        </header>
        <div className="w3-content w3-justify w3-text-grey w3-padding-32" id="about">
          <h2>About Me</h2>
          <hr className="w3-opacity" />
          <p>I have 7+ years of experience as a UI/React/React-native Developer looking to work in a fast-paced organization where challenging problems help in the growth of both the organization and myself.</p>
          {/* <p>
          I love to code. Goal Oriented. Like to work in fun cool friendly environment companies.
          Dedicated to work. Believes in learning new technologies. Web Tech interests me,but at same time AI/ML enthusiast also.
          </p> */}
          {/* <p>Work Philosphy, I give you quality CODE you give me quantity MONEY. LOL. Just kidding. I take care of company as and when in whatever way required with expectation of  vice-versa.</p> */}
          <br/>
          <h3  id="myskills">My Skills</h3>
          <div style={{display:'none'}}>
          <p className="w3-wide">Javascript</p>
          <div className="w3-light-grey">
            <div className="w3-container w3-center w3-padding-small w3-dark-grey" style={{width:"90%"}}>9/10</div>
          </div>
          <p className="w3-wide">React JS</p>
          <div className="w3-light-grey">
            <div className="w3-container w3-center w3-padding-small w3-dark-grey" style={{width:"85%"}}>8.5/10</div>
          </div>
          <p className="w3-wide">React Native</p>
          <div className="w3-light-grey">
            <div className="w3-container w3-center w3-padding-small w3-dark-grey" style={{width:"80%"}}>8/10</div>
          </div>
          <p className="w3-wide" style={{}} >Next JS</p>
          <div className="w3-light-grey">
            <div className="w3-container w3-center w3-padding-small w3-dark-grey" style={{width:"70%"}}>70%</div>
          </div>
          <p className="w3-wide">Node JS</p>
          <div className="w3-light-grey">
            <div className="w3-container w3-center w3-padding-small w3-dark-grey" style={{width:"75%"}}>75%</div>
          </div>
          <p className="w3-wide">Python</p>
          <div className="w3-light-grey">
            <div className="w3-container w3-center w3-padding-small w3-dark-grey" style={{width:"70%"}}>70%</div>
          </div>
          <p className="w3-wide">C/C++</p>
          <div className="w3-light-grey">
            <div className="w3-container w3-center w3-padding-small w3-dark-grey" style={{width:"60%"}}>60%</div>
          </div>
          <p className="w3-wide">HTML</p>
          <div className="w3-light-grey">
            <div className="w3-container w3-center w3-padding-small w3-dark-grey" style={{width:"91%"}}>91%</div>
          </div>
          <p className="w3-wide">CSS</p>
          <div className="w3-light-grey">
            <div className="w3-container w3-center w3-padding-small w3-dark-grey" style={{width:"84%"}}>84%</div>
          </div>
          <p className="w3-wide">Bootstrap</p>
          <div className="w3-light-grey">
            <div className="w3-container w3-center w3-padding-small w3-dark-grey" style={{width:"80%"}}>80%</div>
          </div><br />
          </div>
          <div  className="flex">
            <ul>
              <li className="w3-wide">Javascript</li>
              <li className="w3-wide">Reactjs</li>
              <li className="w3-wide">Nextjs</li>
              <li className="w3-wide">React Native</li>
            </ul>
            <ul>
              <li className="w3-wide">Typescript</li>
              <li className="w3-wide">Node js</li>
              <li className="w3-wide">Express js</li>
              <li className="w3-wide">HTML/CSS</li>
            </ul>
            <ul>
              <li className="w3-wide">Web3.Js</li>
              <li className="w3-wide">Ether.Js</li>
              <li className="w3-wide">Redux/Zustand</li>
              <li className="w3-wide">NoSql & Sql</li>
            </ul>
          </div>


          <h3 className="w3-padding-24" id="workexp"><i className="fa fa-suitcase fa-fw w3-margin-right w3-xxlarge w3-grey-grey"></i>Work Experience</h3>
          <div className="w3-container">
          <a href="https://mystox.co.in" target="_blank">
            <div className="flex">
               <h5 className="w3-opacity"><b>MYSTOX, Bangalore (India) - Founder & Senior Frontend Engineer</b></h5>
               <h6 className="w3-grey-grey"><i className="fa fa-calendar fa-fw w3-margin-right"></i>Nov 2022 – <span className="w3-tag w3-grey w3-round">Current</span></h6>
               </div>
               </a>
               <ul>
                 <li>Designed and developed Fantasy Stock Market Trading App from ground up using React Native</li>
                 <li>Built the fantasy stock market web platform using React.</li>
                 <li>Implemented features including portfolio creation, watchlist, referral, leaderboard, and live trading.</li>
                 <li>Managed team of 3-5 interns for developing and revamping the website and app</li>
                 <li>Developed an Admin Dashboard for monitoring daily analytics using React.</li>
                 <li>Did third-party SDK integration for customer KYC.</li>
               </ul>
               <hr />
          </div>
          <div className="w3-container">
          <a href="https://mudrex.com" target="_blank">
            <div className="flex">

               <h5 className="w3-opacity"><b>Mudrex (Crypto Mutual Fund), Bangalore (India) - Senior engineer</b></h5>
               <h6 className="w3-grey-grey"><i className="fa fa-calendar fa-fw w3-margin-right"></i>June 2022 – Nov 2022</h6>
               </div>
               </a>
               <ul>
                <li>Developed and integrated A/B testing user onboarding for Mudrex App using & React-Native</li>
                <li>Implemented Backend control Product detail Page for all Coins and Coin Sets</li>
                <li>Did third-party Sumsub & Hypervege SDK integration for customer KYC.</li>
                <li>Developed CoinSets and Coin page on web using ReactJS</li>
               </ul>
               <hr />
          </div>
          <div className="w3-container">
          <a href="https://www.makemytrip.com" target="_blank">
            <div className="flex">

               <h5 className="w3-opacity"><b>MakeMyTrip, Bangalore (India) - Senior Software engineer – II</b></h5>
               <h6 className="w3-grey-grey"><i className="fa fa-calendar fa-fw w3-margin-right"></i>March 2021 – June 2022</h6>
               </div>
               </a>
               <ul>
                 <li>Redesigned the desktop application for railways business using functional components and hooks.</li>
                 <li>Developed high-impact features such as trip guarantee and free cancellation for both the web& app</li>
                 <li>Contributed to the implementation of advertisement displays in railway funnels.</li>
                 <li>Cut development time and 2x performance by leveraging shareable components and lazy loading</li>
                 <li>Implemented user behavior and journey tracking on the railway funnel for data analytics.</li>
               </ul>
               <hr />
          </div>
          <div className="w3-container">
          <a href="https://www.soroco.com" target="_blank">
            <div className="flex">

               <h5 className="w3-opacity"><b>Soroco, Bangalore (India) - Software engineer</b></h5>
               <h6 className="w3-grey-grey"><i className="fa fa-calendar fa-fw w3-margin-right"></i>Jan 2019 – May 2020</h6>
               </div>
               </a>
               <ul>
                <li>Developed the dashboard to show the productivity of the team on Scout Platform used
by Fortune 500 clients</li>
              <li>Developed trial-kit version for Scout Platform that provided a 30 days free trial version</li>
                 <li>Worked closely with Co-Founder Rohan Narayana Murthy for Developing MVP in
collaboration with QLIK which became USP for many company products.</li>
               </ul>
               <hr />
          </div>
          <div className="w3-container">
            <div className="flex">
               <h5 className="w3-opacity"><b>World Trade Bureau - Fullstack Web Developer</b></h5>
               <h6 className="w3-grey-grey"><i className="fa fa-calendar fa-fw w3-margin-right"></i>Aug 2017 - Sept 2018 </h6>
               </div>
               <ul>
                 <li>Created Platform Catalog single-handedly using Python Scripts</li>
                 <li>Created Dashboards for different roles using React and Blaze Templating</li>
                 <li>Correct routing of product enquiry generated anywhere on Platform</li>
                 <li>Microsite for each vendor showing aggregate rating of and products sold by vendor.</li>
                 <li>Module for Uploading bulk products at once via CSV using Python script</li>
               </ul>
               <hr />
          </div>
       
        <h3 className="w3-padding-24" id="education"><i className="fa fa-certificate fa-fw w3-margin-right w3-xxlarge w3-grey-grey"></i>Education</h3>
        <div className="w3-container">
        <div className="flex">
             <h5 className="w3-opacity"><b>PES Institute of Technology, Bangalore</b></h5>
             <h6 className="w3-grey-grey"><i className="fa fa-calendar fa-fw w3-margin-right"></i>June 2017</h6>
        </div>
             <ul>
               <li>B.E Major in <b>Electronics and Communication</b></li>
             </ul>
             <hr />
        </div>
         <div className="w3-container" style={{display:'none'}}>
          <div className="flex">
              <h5 className="w3-opacity"><b>Sir Padampat Singhania School</b></h5>
              <h6 className="w3-text-grey"><i className="fa fa-calendar fa-fw w3-margin-right"></i>June 2012</h6>
            </div>

              <ul>
                <li>Graduated High School</li>
              </ul>
              <hr />
            </div>
        </div>



        <div className=" w3-content w3-text-grey" id="contact" style={{marginBottom:"64px"}}>
          <h2>Contact Me</h2>
          <hr className="w3-opacity" />

          <div className="w3-section">
            <p><i className="fa fa-map-marker fa-fw w3-xxlarge w3-margin-right"></i> Bengaluru, Karnataka India</p>
            <p><i className="fa fa-phone fa-fw w3-xxlarge w3-margin-right"></i> Phone: +91-9591681600</p>
            <p><i className="fa fa-envelope fa-fw w3-xxlarge w3-margin-right"> </i> Email: amanjeetgilard@gmail.com</p>
          </div>
          <p>Lets get in touch. Send me a message:</p>
          <form style={{display:'none'}} onSubmit={this.handleAddOption}>
            <p>
              <button className="w3-button w3-light-grey w3-padding-large" type="submit">
                <i className="fa fa-paper-plane"></i> SEND MESSAGE
              </button>
              <div id="sent"></div>
            </p>
          </form>
        </div>
      </div>




      </div>
    );
  }
}

export default Resume;
